/* @flow */

import { connect } from 'react-redux';
import { clearSearch, searchPlayersList } from 'app/actions/playerListActions';
import SearchBar from '../commons/SearchBar';

function mapStateToProps(state) {
  return {
    value: state.playerList.searchTerm,
    placeholder: 'Player Search'
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onClear() {
      dispatch(clearSearch());
    },
    onSearch(value) {
      dispatch(searchPlayersList(value));
    }
  };
}

const PlayerSearchBar = connect(mapStateToProps, mapDispatchToProps)(SearchBar);

export default PlayerSearchBar;
